export enum PersistentFilterProperties {
  CONTROLLING_FILTER = 'ControllingFilter',
  TIMESHEETS_FILTER = 'TimesheetFilterSettings',
}
